import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { getSidebarData } from './SidebarData';
import SubMenu from './SubMenu';
import { useAuth } from "../context/AuthContext";
import { Box, Typography, Avatar, Divider, Drawer, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';

const defaultLogo = `${process.env.PUBLIC_URL}/logo.png`;

const SidebarContainer = styled.div`
  background: linear-gradient(180deg, #001F3F 0%, #00152a 100%);
  height: 100vh;
  width: 280px;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  color: #fff;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
  border-right: 1px solid rgba(255, 255, 255, 0.05);

  /* Custom Scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(58, 107, 126, 0.5);
    border-radius: 4px;
    &:hover {
      background: rgba(58, 107, 126, 0.7);
    }
  }
`;

const SidebarHeader = styled.div`
  padding: 24px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: sticky;
  top: 0;
  z-index: 10;
  backdrop-filter: blur(10px);
`;

const LogoImg = styled.img`
  height: 45px;
  max-width: 100%;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
`;

const UserProfile = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Sidebar = ({ isMobile, isOpen, onClose, onToggle }) => {
  const { user, logout } = useAuth();
  const userRol = user?.usu_rol || user?.rol || "";
  const sidebarData = getSidebarData(userRol);
  const location = useLocation();

  const SidebarContent = (
    <SidebarContainer>
      <SidebarHeader>
        <Link
          to="/inicio/general"
          style={{ textDecoration: 'none', display: 'inline-block' }}
        >
          <LogoImg src={defaultLogo} alt="Instituto Ecuatoriano de Seguridad Social" />
        </Link>
      </SidebarHeader>

      <Box sx={{ flexGrow: 1, py: 2 }}>
        {sidebarData.map((item, index) => (
          <SubMenu item={item} key={index} closeSidebar={isMobile ? onClose : undefined} />
        ))}
      </Box>
    </SidebarContainer>
  );

  if (isMobile) {
    return (
      <>
        <IconButton
          onClick={onToggle}
          sx={{
            position: 'fixed',
            top: 15,
            left: 15,
            zIndex: 1100,
            bgcolor: '#001F3F',
            color: '#fff',
            '&:hover': { bgcolor: '#003366' }
          }}
        >
          <MenuIcon />
        </IconButton>
        <Drawer
          anchor="left"
          open={isOpen}
          onClose={onClose}
          PaperProps={{
            sx: { 
              backgroundColor: 'transparent', 
              border: 'none',
              width: 280,
            }
          }}
        >
          {SidebarContent}
        </Drawer>
      </>
    );
  }

  return SidebarContent;
};

export default Sidebar;
